import React from 'react';
import { Box, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { countryLabelMap } from '../helper';
import { getStateOptions, isStateProvinceRequired, matchAllowedState, referenceCountry, validateStateProvince } from '../stateProvince';

export default function StateProvinceField({ country, value, onChange, validation }) {
    const options = getStateOptions(country, validation.reference);
    const required = isStateProvinceRequired(country);
    const label = countryLabelMap[country] || 'State/Province';
    const result = validateStateProvince({ Country: country, StateProvince: value }, validation.reference, validation.status);
    const message = validation.fieldError || (value && !result.valid ? result.message : '');
    const displayValue = matchAllowedState(value, options, referenceCountry(country, validation.reference)) || value || '';
    const waiting = Boolean(country) && validation.status !== 'ready';
    return <Box>
        {options.length ? <FormControl fullWidth margin="normal" error={Boolean(message)}>
            <InputLabel id="state-province-label">{label}</InputLabel>
            <Select labelId="state-province-label" id="stateProvince" name="StateProvince"
                label={label} value={displayValue} onChange={onChange} disabled={waiting}>
                <MenuItem value=""><em>{required ? 'Select a state/province' : 'No State/Province'}</em></MenuItem>
                {displayValue && !options.includes(displayValue) &&
                    <MenuItem value={displayValue} disabled>{displayValue} (invalid for this country)</MenuItem>}
                {options.map(option => <MenuItem key={option} value={option}>{option}</MenuItem>)}
            </Select>
            <FormHelperText>{message || (required ? 'Required for this country.' : 'Optional for this country.')}</FormHelperText>
        </FormControl> : <TextField fullWidth margin="normal" id="stateProvince" name="StateProvince"
            label={label} value={value || ''} onChange={onChange} disabled={waiting}
            error={Boolean(message)} helperText={message || (waiting ? 'Loading state/province options…' : required ? 'Required for this country.' : '')} />}
        {country && validation.status === 'error' && <Box role="alert">
            State/province options could not be loaded. Saving is blocked until they are available.
            <Button type="button" onClick={validation.retry}>Retry loading options</Button>
        </Box>}
    </Box>;
}
